angular.
module("dx.webapp.suggestionDropdown").
controller("DxSuggestionDropdownController", function SuggestionDropdownController(
	$scope,

	DX_KEY_CODES
) {
	"use strict";
	var self = this;
	self.preparedSuggestions = [];
	self.highlightedIndex = 0;
	self.maxLength = self.maxLength > 0 ? self.maxLength : 5;
	var lastIndex = -1;

	$scope.$watch("vm.suggestions", function prepareSuggestions() {
		if (self.suggestions) {
			var listLength = Math.min(self.suggestions.length, self.maxLength);
			self.preparedSuggestions = [];
			for (var i = 0; i < listLength; i++) {
				var entry = self.suggestions[i];
				self.preparedSuggestions.push({
					titlePrimary: entry.highlight[self.keyPrimary] || entry[self.keyParent][self.keyPrimary],
					titleSecondary: entry.highlight[self.keySecondary] || entry[self.keyParent][self.keySecondary],
					subtitle: entry.highlight[self.keyTertiary] || entry[self.keyParent][self.keyTertiary],
				});
			}
			lastIndex = listLength - 1;
			self.highlightedIndex = 0;
		} else {
			self.preparedSuggestions = [];
			lastIndex = -1;
		}
	});

	$scope.$watch("vm.keydownEvent", function listenToKeyDown() {
		if (self.keydownEvent && lastIndex !== -1) {
			switch (self.keydownEvent.keyCode) {
				case DX_KEY_CODES.upArrow:
					self.keydownEvent.preventDefault();
					self.highlightedIndex = Math.max(0, self.highlightedIndex - 1);
					break;
				case DX_KEY_CODES.downArrow:
					self.keydownEvent.preventDefault();
					self.highlightedIndex = Math.min(lastIndex, self.highlightedIndex + 1);
					break;
				case DX_KEY_CODES.enter:
					self.keydownEvent.preventDefault();
					self.select({index: self.highlightedIndex});
					break;
			}
		}
	});

	self.select = function select(index) {
		self.onChoose(index);
		self.highlightedIndex = 0;
		self.preparedSuggestions = [];
		lastIndex = -1;
	};
});
